<template>
  <Dialog v-model:visible="showModal" :draggable="false" modal :header="isEdit ? 'Upraviť kategóriu' : 'Pridať kategóriu'"
          :style="{ width: '32rem', maxWidth: '95vw' }">

    <div class="flex flex-col gap-1">
      <label class="text-surface-500 text-sm" for="category-name-sk">Názov SK</label>
      <InputText id="category-name-sk" v-model="state.name" size="small"/>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-surface-500 text-sm" for="category-name-cz">Názov CZ</label>
      <InputText id="category-name-cz" v-model="state.name_cz" size="small"/>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-surface-500 text-sm" for="category-name-en">Názov EN</label>
      <InputText id="category-name-en" v-model="state.name_en" size="small"/>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-surface-500 text-sm" for="category-name-de">Názov DE</label>
      <InputText id="category-name-de" v-model="state.name_de" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-title-sk">Titulok SK</label>
      <InputText id="category-title-sk" v-model="state.title" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-title-cz">Titulok CZ</label>
      <InputText id="category-title-cz" v-model="state.title_cz" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-title-en">Titulok EN</label>
      <InputText id="category-title-en" v-model="state.title_en" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-title-de">Titulok DE</label>
      <InputText id="category-title-de" v-model="state.title_de" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-description-sk">Popis SK</label>
      <InputText id="category-description-sk" v-model="state.description" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-description-cz">Popis CZ</label>
      <InputText id="category-description-cz" v-model="state.description_cz" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-description-en">Popis EN</label>
      <InputText id="category-description-en" v-model="state.description_en" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-description-de">Popis DE</label>
      <InputText id="category-description-de" v-model="state.description_de" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-icon">Ikona</label>
      <InputText id="category-icon" v-model="state.icon" size="small"/>
    </div>

    <div class="flex flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="category-order">Poradie</label>
      <InputNumber inputId="category-order" v-model="state.order" :min="0" :useGrouping="false" size="small"/>
    </div>

    <div class="mt-4 grid gap-4 sm:grid-cols-2 sm:items-end">
      <div>
        <div id="category-active-label" class="text-sm font-semibold text-surface-700">Kategória aktívna</div>
        <div class="mt-1 text-xs text-surface-500">Vypnutá kategória sa nezobrazí v žiadnom novom menu.</div>
        <ToggleButton v-model="state.menuActive"
                      class="mt-2"
                      onLabel="Áno"
                      offLabel="Nie"
                      size="sm"
                      aria-labelledby="category-active-label"/>
      </div>

      <div>
        <div id="category-place-label" class="mb-2 text-sm font-semibold text-surface-700">Prevádzka</div>
      <SelectButton v-model="state.restaurantPlace"
                    :options="RESTAURANT_PLACES"
                    :allowEmpty="false"
                    aria-labelledby="category-place-label"
                    size="small"
                    option-value="value"
                    optionLabel="name"
      />
      </div>
    </div>

    <hr class="my-4">

    <section class="rounded-lg border border-primary-200 bg-primary-50 p-3">
      <div id="category-visibility-label" class="font-semibold text-primary-700">Kedy sa kategória zobrazí</div>
      <div class="mt-1 text-xs text-surface-500">
        Rozvoz zahŕňa aj osobný odber. Existujúce kategórie zostávajú predvolene dostupné v oboch režimoch.
      </div>

      <div v-if="state.orderVisibility !== ORDER_VISIBILITY.BOTH"
           class="mt-3 rounded-md border border-orange-200 bg-orange-50 px-3 py-2 text-xs text-orange-700">
        Staršie verzie aplikácie túto obmedzenú kategóriu z bezpečnostných dôvodov nezobrazia vôbec.
        V správnom režime ju zobrazí nová verzia aplikácie.
      </div>

      <SelectButton v-model="state.orderVisibility"
                    :options="orderVisibilityOptions"
                    :allowEmpty="false"
                    :disabled="!categoryVisibilitySupported"
                    option-value="value"
                    optionLabel="label"
                    aria-labelledby="category-visibility-label"
                    class="mt-3 flex flex-wrap"
                    size="small"/>

      <div v-if="!categoryVisibilitySupported"
           class="mt-3 rounded-md border border-orange-200 bg-orange-50 px-3 py-2 text-xs text-orange-700">
        Databázová schéma zatiaľ nepodporuje filtrovanie kategórií. Kategóriu je stále možné bezpečne uložiť
        s pôvodným správaním.
      </div>
    </section>

    <hr class="my-4">

    <div class="flex flex-col gap-4">
      <section class="rounded-lg border border-surface-200 bg-surface-50 p-3">
        <div class="mb-3">
          <div class="font-semibold text-surface-700">Objednávka na adresu / osobný odber</div>
          <div class="mt-1 text-xs text-surface-500">
            Pôvodné nastavenie používané pri objednávke na adresu alebo osobnom odbere.
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div>
            <b class="text-surface-500 text-sm">Príloha 1</b>
            <MySelect v-model="state.mealExtraId_1"
                      :options="mealsExtraOptions"
                      placeholder="Vyberte skupinu príloh"
                      class="mt-1 w-full"
            />
          </div>

          <div>
            <b class="text-surface-500 text-sm">Príloha 2</b>
            <MySelect v-model="state.mealExtraId_2"
                      :options="mealsExtraOptions"
                      placeholder="Vyberte skupinu príloh"
                      class="mt-1 w-full"
            />
          </div>

          <div>
            <b class="text-surface-500 text-sm">Príloha 3</b>
            <MySelect v-model="state.mealExtraId_3"
                      :options="mealsExtraOptions"
                      placeholder="Vyberte skupinu príloh"
                      class="mt-1 w-full"
            />
          </div>
        </div>
      </section>

      <section class="rounded-lg border border-primary-200 bg-primary-50 p-3">
        <div class="mb-3">
          <div class="font-semibold text-primary-700">Objednávka od stola</div>
          <div class="mt-1 text-xs text-surface-500">
            Samostatné skupiny príloh zobrazované iba pri objednávke od stola.
          </div>
        </div>

        <div v-if="!tableMealExtrasSupported"
             class="mb-3 rounded-md border border-orange-200 bg-orange-50 px-3 py-2 text-xs text-orange-700">
          Databázová schéma zatiaľ neobsahuje polia pre prílohy objednávky od stola. Pôvodné nastavenie
          kategórie je možné naďalej uložiť.
        </div>

        <div class="flex flex-col gap-3">
          <div>
            <b class="text-surface-500 text-sm">Príloha 1</b>
            <MySelect v-model="state.tableMealExtraId_1"
                      :options="mealsExtraOptions"
                      :disabled="!tableMealExtrasSupported"
                      placeholder="Vyberte skupinu príloh"
                      class="mt-1 w-full"
            />
          </div>

          <div>
            <b class="text-surface-500 text-sm">Príloha 2</b>
            <MySelect v-model="state.tableMealExtraId_2"
                      :options="mealsExtraOptions"
                      :disabled="!tableMealExtrasSupported"
                      placeholder="Vyberte skupinu príloh"
                      class="mt-1 w-full"
            />
          </div>

          <div>
            <b class="text-surface-500 text-sm">Príloha 3</b>
            <MySelect v-model="state.tableMealExtraId_3"
                      :options="mealsExtraOptions"
                      :disabled="!tableMealExtrasSupported"
                      placeholder="Vyberte skupinu príloh"
                      class="mt-1 w-full"
            />
          </div>
        </div>
      </section>
    </div>

    <hr class="my-4">
    <div class="flex   " :class="isEdit ? 'justify-between':'justify-end'">
      <Button v-if="isEdit" :loading="deleting" type="button" size="small" label="Zmazať" severity="danger"
              class="self-start"
              @click="deleteThisCategory"></Button>
      <div class="flex gap-2">
        <Button type="button" label="Zrušiť" :disabled="loading || deleting" size="small" severity="secondary"
                @click="showModal = false"></Button>
        <Button @click="addNewCategory" :disabled="deleting" :loading="loading" size="small" label="Uložiť"
                icon="pi pi-check"
                iconPos="right"/>
      </div>
    </div>

  </Dialog>
</template>

<script>

import {reactive, ref} from "vue";
import {
  CATEGORY_VISIBILITY_FIELDS,
  ORDER_VISIBILITY,
  legacyActiveForCategory,
  nextVisibilityRevision,
  normalizeOrderVisibility,
  supportsCategoryVisibility,
  visibilityWriteMatches
} from "@/utils/categoryVisibility.js";

const TABLE_MEAL_EXTRA_FIELDS = [
  'tableMealExtraId_1',
  'tableMealExtraId_2',
  'tableMealExtraId_3'
]

const EMPTY_CATEGORY = {
  id: null,
  name: '',
  name_cz: '',
  name_en: '',
  name_de: '',
  title: '',
  title_cz: '',
  title_en: '',
  title_de: '',
  description: '',
  description_cz: '',
  description_en: '',
  description_de: '',
  icon: '',
  active: true,
  menuActive: true,
  orderVisibility: ORDER_VISIBILITY.BOTH,
  visibilityRevision: 0,
  restaurantPlace: 'BO',
  mealExtraId_1: null,
  mealExtraId_2: null,
  mealExtraId_3: null,
  tableMealExtraId_1: null,
  tableMealExtraId_2: null,
  tableMealExtraId_3: null,
  order: 0
}

const showModal = ref(false)
const state = reactive({...EMPTY_CATEGORY})
const CATEGORY_FIELDS = Object.keys(EMPTY_CATEGORY)
const pendingCreateId = ref(null)

const resetCategoryState = () => {
  Object.keys(state).forEach(key => delete state[key])
  Object.assign(state, EMPTY_CATEGORY)
}

export const openCategory = (values = null) => {
  resetCategoryState()
  pendingCreateId.value = null

  if (!values) {
    delete state.id
  } else {
    CATEGORY_FIELDS.forEach(field => {
      if (Object.prototype.hasOwnProperty.call(values, field)) state[field] = values[field]
    })
    state.menuActive = values.menuActive ?? values.active ?? true
    state.orderVisibility = normalizeOrderVisibility(values.orderVisibility)
  }
  showModal.value = true
}

</script>

<script setup>
import {computed, ref} from "vue";
import {useToast} from "primevue/usetoast";
import useContentStore from "@/stores/contentStore.js";
import {useConfirm} from "primevue/useconfirm";
import Supabase from "@/utils/Supabase.js";
import {RESTAURANT_PLACES} from "@/content/lists.js";
import MySelect from "@/components/inputs/MySelect.vue";
import {v4 as uuidv4} from "uuid";

const toast = useToast();
const confirm = useConfirm();
const contentStore = useContentStore()

const isEdit = computed(() => state.id)
const loading = ref(false)

const orderVisibilityOptions = [
  {label: 'Rozvoz / osobný odber', value: ORDER_VISIBILITY.STANDARD},
  {label: 'Od stola', value: ORDER_VISIBILITY.TABLE_ORDER},
  {label: 'Oba spôsoby', value: ORDER_VISIBILITY.BOTH}
]

const mealsExtraOptions = computed(() => (contentStore.mealsExtrasList[state.restaurantPlace] ?? []).map(item => ({
  title: `${item.name} - ${item.title}`,
  value: item.id
})))

const tableMealExtrasSupported = computed(() => contentStore.appCategories.some(category =>
  TABLE_MEAL_EXTRA_FIELDS.every(field => Object.prototype.hasOwnProperty.call(category, field))
))

const categoryVisibilitySupported = computed(() => supportsCategoryVisibility(contentStore.appCategories))

const addNewCategory = async () => {
  loading.value = true
  let categoryInserted = false
  try {
    const categoryData = Object.fromEntries(
      CATEGORY_FIELDS
        .filter(field => Object.prototype.hasOwnProperty.call(state, field))
        .map(field => [field, state[field]])
    )
    const creatingCategory = !categoryData.id

    // Zachová uloženie pôvodných kategórií, kým databáza nedostane nové stĺpce.
    if (!tableMealExtrasSupported.value) {
      TABLE_MEAL_EXTRA_FIELDS.forEach(field => delete categoryData[field])
    }

    if (categoryVisibilitySupported.value) {
      categoryData.orderVisibility = normalizeOrderVisibility(categoryData.orderVisibility)
      categoryData.menuActive = Boolean(categoryData.menuActive)
      categoryData.active = legacyActiveForCategory(categoryData)
    } else {
      categoryData.active = Boolean(categoryData.menuActive)
      CATEGORY_VISIBILITY_FIELDS.forEach(field => delete categoryData[field])
    }

    let savedCategory

    if (creatingCategory) {
      const insertData = {...categoryData}
      CATEGORY_VISIBILITY_FIELDS.forEach(field => delete insertData[field])
      insertData.id = pendingCreateId.value ?? uuidv4()
      pendingCreateId.value = insertData.id

      const {data, error} = await Supabase
        .from('v2_Hajcer_App_Categories')
        .upsert(insertData)
        .select()
        .single()
      if (error) throw error
      savedCategory = data
      state.id = savedCategory.id
      state.visibilityRevision = savedCategory.visibilityRevision
      pendingCreateId.value = null
      categoryInserted = true

      if (categoryVisibilitySupported.value) {
        const requestedVisibility = {
          active: categoryData.active,
          menuActive: categoryData.menuActive,
          orderVisibility: categoryData.orderVisibility,
          visibilityRevision: nextVisibilityRevision(savedCategory.visibilityRevision)
        }
        const {data: visibilityData, error: visibilityError} = await Supabase
          .from('v2_Hajcer_App_Categories')
          .update(requestedVisibility)
          .eq('id', savedCategory.id)
          .eq('visibilityRevision', savedCategory.visibilityRevision)
          .select()
          .maybeSingle()
        if (visibilityError) throw visibilityError
        if (!visibilityWriteMatches(visibilityData, requestedVisibility)) {
          throw new Error('Kategória vznikla v bezpečnom pôvodnom režime, ale jej režim sa nepodarilo uložiť. Otvorte ju a skúste to znova.')
        }
        savedCategory = visibilityData
      }
    } else if (categoryVisibilitySupported.value) {
      const originalRevision = Number(categoryData.visibilityRevision)
      categoryData.visibilityRevision = nextVisibilityRevision(originalRevision)

      const {data, error} = await Supabase
        .from('v2_Hajcer_App_Categories')
        .update(categoryData)
        .eq('id', categoryData.id)
        .eq('visibilityRevision', originalRevision)
        .select()
        .maybeSingle()
      if (error) throw error
      if (!visibilityWriteMatches(data, categoryData)) {
        throw new Error('Kategóriu medzitým upravil niekto iný. Skontrolujte aktuálne nastavenie a skúste to znova.')
      }
      savedCategory = data
    } else {
      const {data, error} = await Supabase
        .from('v2_Hajcer_App_Categories')
        .upsert(categoryData)
        .select()
        .single()
      if (error) throw error
      savedCategory = data
    }

    toast.add({severity: 'success', summary: 'Uložené', detail: 'Kategória bola uložená.', life: 3000});
    showModal.value = false
    await contentStore.loadCategories()
  } catch (error) {
    toast.add({severity: 'error', summary: 'Kategóriu sa nepodarilo uložiť', detail: error.message, life: 5000});
    if (categoryInserted) {
      showModal.value = false
      await contentStore.loadCategories()
    }
  } finally {
    loading.value = false
  }
}

const deleting = ref(false)
const deleteThisCategory = () => {
  confirm.require({
    message: 'Naozaj chcete túto kategóriu zmazať?',
    header: 'Zmazanie kategórie',
    icon: 'pi pi-info-circle',
    rejectLabel: 'Zrušiť',
    rejectProps: {
      label: 'Zrušiť',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Zmazať',
      severity: 'danger'
    },
    accept: async () => {
      deleting.value = true
      try {
        const {error} = await Supabase.from('v2_Hajcer_App_Categories').delete().eq('id', state.id)
        if (error) throw error

        toast.add({severity: 'success', summary: 'Zmazané', detail: 'Kategória bola zmazaná.', life: 3000});
        await contentStore.loadCategories()
        showModal.value = false
      } catch (error) {
        toast.add({severity: 'error', summary: 'Kategóriu sa nepodarilo zmazať', detail: error.message, life: 5000});
      } finally {
        deleting.value = false
      }
    }
  });
}


</script>
